import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgButtonArrowBack = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M33.1562 44.9332L14.9995 25.5001",
		stroke: "currentColor",
		strokeWidth: 4,
		strokeLinecap: "round"
	}), /* @__PURE__ */ _jsx("line", {
		x1: 15,
		y1: 25.1716,
		x2: 34.1717,
		y2: 5.99984,
		stroke: "currentColor",
		strokeWidth: 4,
		strokeLinecap: "round"
	})]
});
export default SvgButtonArrowBack;
